import { render, staticRenderFns } from "./IntegrationSelector.vue?vue&type=template&id=2c8ce4f6&lang=pug&"
import script from "./IntegrationSelector.vue?vue&type=script&lang=js&"
export * from "./IntegrationSelector.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationSelector.vue?vue&type=style&index=0&id=2c8ce4f6&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports